import { SHORT_DISCLAIMER } from "@netkeep/legal";
import { useEffect } from "react";
import { Link, NavLink, Outlet, ScrollRestoration, useLocation } from "react-router";
import { applyUpdate, usePwa } from "@/lib/pwa";
import { TABS } from "@/lib/tabs";
import { Icon } from "./Icon";
import { LegalLinks } from "./LegalLinks";
import { Button } from "./ui";

function NavLinks() {
  return (
    <>
      {TABS.map((tab) => (
        <NavLink key={tab.path} to={tab.path} end className="nav__link">
          <Icon name={tab.icon} />
          <span>{tab.title}</span>
        </NavLink>
      ))}
    </>
  );
}

/** Top bar with tabs on wide screens; bottom tab bar on phones (like the mobile app). */
export function AppShell() {
  const { pathname } = useLocation();
  const title = TABS.find((t) => t.path === pathname)?.title;
  const { updateReady } = usePwa();

  useEffect(() => {
    // Legal pages set their own title.
    if (pathname === "/terms" || pathname === "/privacy") return;
    document.title = title && title !== "Calculator" ? `${title} · NetKeep` : "NetKeep";
  }, [pathname, title]);

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <header className="topbar">
        <div className="topbar__inner">
          <Link to="/" className="logo" aria-label="NetKeep home">
            Net<span>Keep</span>
          </Link>
          <nav className="nav" aria-label="Main">
            <NavLinks />
          </nav>
        </div>
      </header>
      <div className="page">
        <main id="main" className="page__main">
          {updateReady ? (
            <div className="update-bar" role="status">
              <span className="grow">A new version of NetKeep is ready.</span>
              <Button title="Reload" variant="secondary" onClick={applyUpdate} />
            </div>
          ) : null}
          <Outlet />
        </main>
        <footer className="footer">
          <p>{SHORT_DISCLAIMER}</p>
          <p>Not affiliated with or endorsed by any marketplace or payment provider.</p>
          <LegalLinks />
        </footer>
      </div>
      <nav className="tabbar" aria-label="Main">
        <NavLinks />
      </nav>
      <ScrollRestoration />
    </>
  );
}
